// @flow

import * as React from 'react';

import type { PreFetchArgs, StaticHandlerArgs } from '@gandi/app-runner/server';
import { PaymentReturn } from '@gandi/billing';

import { createLogger } from 'gandi.redux-logger';

import { useQuery, withRouter } from '../helpers/withRouter';
import type { FullState } from '../types';

export type Query = {
  order?: string,
  retry?: string,
  status?: string,
};

/**
 * Wrapper for concret PaymentReturn
 * XXX: another PaymentReturnWrapper already exist and can probably be merged
 */
function PaymentReturnBase() {
  const { order, retry, status } = useQuery<Query>();

  // $FlowFixMe[incompatible-use]: status should be sanitized
  return <PaymentReturn orderId={order} retryURL={retry} status={status} />;
}

PaymentReturnBase.preFetch = (args: PreFetchArgs<void, {}, Query>) => {
  return PaymentReturn.preFetch({
    ...args,
    orderId: args.query.order,
  });
};

PaymentReturnBase.handleRedirect = async function handleRedirect({
  query,
  res,
}: StaticHandlerArgs<void, {}, Query, FullState>): Promise<void> {
  // route the user to the retry page when payment went wrong
  // the retry page is set earlier during the checkout
  // and should be the checkout page with a message depending of the status
  // this way we are allowing the user to try another way to pay
  if (['failed', 'cancel'].includes(query.status)) {
    if (query.retry && query.status) {
      try {
        // retry is a full url useful to build the querystring properly
        // if url is invalid it will crash
        const redirectURL = new URL(query.retry);
        redirectURL.searchParams.set('status', query.status || '');

        // we only need the pathname and params for soft redirect
        res.redirect(`${redirectURL.pathname}${redirectURL.search}`);
      } catch (err) {
        const logger = createLogger('PaymentReturnBase/handleRedirect');

        logger.error(
          { err },
          'Error while redirecting user to payment page due to failed attempt.',
        );
      }
    }
  }
};
export default (withRouter(PaymentReturnBase): React.ComponentType<{}>);
